import { useState } from 'react';
import { styled } from '@mui/material/styles';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import SaveIcon from '@mui/icons-material/Save';
import ShareIcon from '@mui/icons-material/Share';

const Root = styled('div')({
  right: 10,
  bottom: 10,
  position: 'fixed',
  transform: 'translateZ(0px)',
  flexGrow: 1,
});

const StyledSpeedDial = styled(SpeedDial)({
  '& .MuiFab-primary': {
    background: '#54a936',
    '&:hover': {
      background: '#4a9830'
    }
  },
  '& .MuiSpeedDial-actionsClosed': {
    height: 1
  }
});

interface DialActionProps {
  save: () => void;
  share: () => void;
}

export default function DialActions({ save, share }: DialActionProps) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const actions = [
    {
      icon: <SaveIcon />,
      name: 'Save',
      handle: () => {
        save();
        handleClose();
      }
    },
    {
      icon: <ShareIcon />,
      name: 'Share',
      handle: () => {
        share();
        handleClose();
      }
    }
  ];

  return (
    <Root>
      <StyledSpeedDial
        ariaLabel="Actions menu"
        icon={<MoreHorizIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            tooltipOpen
            onClick={action.handle}
          />
        ))}
      </StyledSpeedDial>
    </Root>
  );
}
